import {useEffect} from 'react';

import {
  chatSubscriptionRegistry,
  modelSubscriptionRegistry,
} from './subscriptionRegistry';
import {ModelChangeMessageType} from './types';
import {
  allFieldsMatch,
  allRelatedMatch,
  anyModelMatch,
  anyRelatedMatch,
  modelIdMatch,
  runWhenAll,
  runWhenAllFieldsMatch,
  runWhenAllRelatedMatch,
  runWhenAny,
  runWhenAnyModelMatch,
  runWhenModelIdMatch,
} from './utils';

const subscriptionUtils = {
  runWhenAll,
  modelIdMatch,
  anyModelMatch,
  allRelatedMatch,
  allFieldsMatch,
  runWhenModelIdMatch,
  runWhenAllFieldsMatch,
  runWhenAnyModelMatch,
  runWhenAllRelatedMatch,
  runWhenAny,
  anyRelatedMatch,
};

export type WSModelChangeMessageHandler = (
  message: ModelChangeMessageType,
  utils: typeof subscriptionUtils
) => unknown;

export function useModelChangeSubscription(
  handler: WSModelChangeMessageHandler,
  inputs: Array<any>
): void {
  useEffect(() => {
    if (window.WebSocket) {
      const localHandler = (message) => handler(message, subscriptionUtils);
      modelSubscriptionRegistry.register(localHandler);
      return () => modelSubscriptionRegistry.unregister(localHandler);
    }
  }, inputs);
}

export type WSChatMessageHandler = (
  message: {
    message: string;
    type:
      | 'error'
      | 'heartbeat'
      | 'edit_procedure_chat'
      | 'edit_policy_chat'
      | 'edit_text_chat';
    thread_id?: string;
  },
  utils: typeof subscriptionUtils
) => unknown;

export function useChatMessageSubscription(
  handler: WSChatMessageHandler,
  inputs: Array<any>
): void {
  useEffect(() => {
    if (window.WebSocket) {
      const localHandler = (message) => handler(message, subscriptionUtils);
      chatSubscriptionRegistry.register(localHandler);
      return () => chatSubscriptionRegistry.unregister(localHandler);
    }
  }, inputs);
}
